// --------------------------------------------------------------
// Created On: 2022-09-20
// Author: Zachary Thomas
//
// Last Modified: 2026-07-31
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./HelpAsset.module.scss";

// Explains what an asset is.
export default function HelpAsset(): Component {
  return (
    <div>
      <p className="px-3">
        An asset represents anything that you can track and manage. An asset may be comprised of the following parts.
      </p>

      <p className="px-3 mt-3 mb-2">
        <b>Product:</b> Each asset has a product. A product can be a pump, generator, or anything else that can be
        tracked and managed.
      </p>

      <p className="px-3 mt-3 mb-2">
        <b>Monitoring Device:</b> Some assets have a monitoring device. A monitoring device collects information such as
        location, temperature, and vibration and transmits it to the application.
      </p>

      <p className="px-3 mt-3 mb-2">
        <b>Modbus Device:</b> Some monitoring devices support linking Modbus devices. A Modbus controller provides
        additional data and supports remote operation (start, stop, speed change, etc.), while a Modbus sensor only
        reports additional data.
      </p>

      <p className="px-3 mt-3 mb-2">
        <b>Sensor:</b> Some monitoring devices support plug-in sensors. Input sensors report additional data such as
        pressure or flow that the monitoring device itself does not capture. Output sensors send signals to a linked
        device, enabling remote operation of external equipment.
      </p>

      <div className="row justify-content-center">
        <div className="col-12 col-lg-6 p-2">
          <img className={styles.image} src="/images/asset_info_1.png" alt="Asset with only a product." />
        </div>

        <div className="col-12 col-lg-6 p-2">
          <img
            className={styles.image}
            src="/images/asset_info_2.png"
            alt="Asset with a product, controller, and monitoring device."
          />
        </div>
      </div>
    </div>
  );
}
